// extracted by mini-css-extract-plugin
module.exports = {"TitleSection":"ChangePassword__TitleSection__2r-X"};